import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";
import { AccordionOnlyUseBasic } from "@/components/features/items/edit/_shared/ui/components/system/accordion/only-use-basic/accordion";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	hotelID: string;
	isSecret: ForNodeType<boolean>;
	onSetIsSecret: (value: boolean) => void;
};

export const QuestionPlanIsSecret = ({ hotelID, isSecret, onSetIsSecret }: Props) => {
	const label = "シークレットプラン";
	const guide =
		"URLを知っている人だけがアクセスできるシークレットプランをつくることができます。 株主優待や、会員向けのサービスとしてご利用ください。";

	return (
		<AccordionOnlyUseBasic
			hotelID={hotelID}
			defaultOpen={isSecret.isEdited}
			accordionTitle="シークレットプランに関する設定"
		>
			<FeatureIslandCategoryQuestionForMain
				required={false}
				title={label}
				guide={guide}
				isEdited={isSecret.isEdited}
				hasError={Boolean(isSecret.error)}
				inputChildren={
					<CheckboxField
						value={isSecret.value}
						label={"シークレットプランにする"}
						handleChange={onSetIsSecret}
						errorMessage={isSecret.error}
					/>
				}
			/>
		</AccordionOnlyUseBasic>
	);
};

QuestionPlanIsSecret.displayName = "QuestionPlanIsSecret";
